// config/consts.js
const constants = {
    // API URL
    // serverUrl: 'http://localhost:3025',
    serverUrl: 'https://api.katiadoodletoys.ru',
    
    // Роли администраторов
    ROLES: {
        SUPERADMIN: 'superadmin',
        ADMIN: 'admin',
        EDITOR: 'editor',
        DEVELOPER: 'developer',
        VIEWER: 'viewer'
    },
    
    // Статусы товаров
    PRODUCT_STATUS: {
        ACTIVE: 'active',
        ARCHIVE: 'archive'
    },
    
    // Права доступа по ролям
    ROLE_PERMISSIONS: {
        superadmin: {
            canViewProducts: true,
            canManageProducts: true,
            canEditProducts: true,
            canDeleteProducts: true,
            canChangeProductStatus: true,
            canManageAdmins: true,
            canViewOrders: true,
            canManageOrders: true,
            canEditOrders: true,
            canDeleteOrders: true,
        },
        admin: {
            canViewProducts: true,
            canManageProducts: true,
            canEditProducts: true,
            canDeleteProducts: true,
            canChangeProductStatus: true,
            canManageAdmins: false,
            canViewOrders: true,
            canManageOrders: true,
            canEditOrders: true,
            canDeleteOrders: true,
        },
        editor: {
            canViewProducts: true,
            canManageProducts: false,
            canEditProducts: true,
            canDeleteProducts: false,
            canChangeProductStatus: true,
            canManageAdmins: false,
            canViewOrders: true,
            canManageOrders: false,
            canEditOrders: true,
            canDeleteOrders: false,
        },
        developer: {
            canViewProducts: true,
            canManageProducts: true,
            canEditProducts: true,
            canDeleteProducts: true,
            canChangeProductStatus: true,
            canManageAdmins: true,
            canViewOrders: true,
            canManageOrders: true,
            canEditOrders: true,
            canDeleteOrders: true,
        },
        viewer: {
            canViewProducts: true,
            canManageProducts: false,
            canEditProducts: false,
            canDeleteProducts: false,
            canChangeProductStatus: false,
            canManageAdmins: false,
            canViewOrders: false,
            canManageOrders: false,
            canEditOrders: false,
            canDeleteOrders: false,
        }
    },
    CATEGORIES: ['Doodle Toys', 'Открытки', 'Постеры', 'Кубики', 'Магниты'],
    TOY_TYPES: ['Собаки и кошки', 'Персонажи', 'Всадники', 'Звери', 'Птицы', 'Букашки', 'Пары', '3D', 'Разные'],
    CARDS_TYPES: ['10х15 100 р.', '15х20 150 р.', 'Doodle Toys', 'Рисунки', 'Узоры', 'Разные']
};

export default constants;